module.exports = __webpack_public_path__ + "img/icon3s.8da07a86.png";